import React from 'react';
import { Outlet } from 'react-router-dom';
import './reports.scss';

const ReportOutlet = () => {
    return (
        <div className='reports'>
            <Outlet />
        </div>
    )
}

export default ReportOutlet;